import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DesyAngularModule } from 'desy-angular';

@Component({
  selector: 'app-tooltip',
  imports: [CommonModule, DesyAngularModule],
  templateUrl: './tooltip.component.html',
  styleUrls: ['./tooltip.component.scss'],
  standalone: true,
})
export class TooltipComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() tipeIcon = '';
}
